// extracted by mini-css-extract-plugin
export default {"header":"Styles_header__-QgWB","footer":"Styles_footer__IxGPu","title":"Styles_title__CIWOx","button":"Styles_button__qs+FI","blockOverlay":"Styles_blockOverlay__RJa33"};